var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Zm2 0A9 9 0 1 1 0 9a9 9 0 0 1 18 0ZM5.03 10.095l2.263 2.262a1 1 0 0 0 1.414 0l4.596-4.596a1 1 0 0 0-1.414-1.414L8 10.236 6.445 8.68a1 1 0 1 0-1.415 1.415Z"
  })));
};
export default SvgSuccess;